import { useAppSelector } from "@/store/hooks";
import { Link } from "react-router-dom";
// import { useTheme } from "./ThemeProvider";

type LogoSize = "sm" | "md" | "lg" | "xl";

interface LogoProps {
  size?: LogoSize;
  className?: string;
  homeLink?: boolean;
  iconOnly?: boolean;
  alt?: string;
}

const logoSizes: Record<LogoSize, string> = {
  sm: "h-7",
  md: "h-9",
  lg: "h-12",
  xl: "h-20",
};

export const Logo = ({
  size = "md",
  className = "",
  homeLink = true,
  iconOnly = false,
  alt = "Techbravery",
}: LogoProps) => {
  const theme = useAppSelector((state) => state.ui.theme);

  const isDark = theme === "dark";

  const logoSrc = iconOnly
    ? isDark
      ? "/dark-logo-icon.jpg"
      : "/light-logo-icon.jpg"
    : isDark
      ? "/dark-logo.jpg"
      : "/light-logo.jpg";

  const image = (
    <img
      src={logoSrc}
      alt={alt}
      draggable={false}
      className={[
        "block w-auto max-w-full object-contain",
        logoSizes[size],
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    />
  );

  if (!homeLink) {
    return image;
  }

  return (
    <Link
      to="/"
      aria-label="Techbravery homepage"
      className="inline-flex min-w-0 items-center"
    >
      {image}
    </Link>
  );
};
